







import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { User } from "../../../domain/user";
import { ModelEditableMixin } from "../../system/mixins";
import { IMultiSelectableAsynchronously } from "../../system/selectors";
import { IMultiOrderableUserListSelectorDialogCondition } from "../../user/dialogs";

@Component({
  components: {
  },
})
export default class DocumentUsersSelector extends Mixins(ModelEditableMixin) {
  // editingSource: User[];

  data() {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  // 初回のアクセス時に取得した結果を保持するようにしている
  private _usersIncludingExpired: User[];

  @Prop()
  dialog: IMultiSelectableAsynchronously<User>;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop({ default: false })
  disabled: boolean;

  @Prop()
  condition: IMultiOrderableUserListSelectorDialogCondition;

  get labelOfSelectedOption(): string {
    return this.editingSource ? this.editingSource.join(",") : "";
  }

  get title(): string {
    return this.labelOfSelectedOption;
  }

  async select(): Promise<void> {
    const users = await this.$commonDialogs.user.multiOrderableListSelector.selectOptionsConditionally(this.condition, this.editingSource);
    if (users === undefined) {
      // undefinedの時はキャンセル.
      return;
    }
    this.editingSource = !!users ? users : [];
  }

  clear(): void {
    this.editingSource = [];
  }

  public async setUsersSelection(userCodes: string[]): Promise<void> {
    const selectingUsers = this.editingSource as User[];
    const selectingUserCodes = selectingUsers ? selectingUsers.map(u => u.id) : [];
    if (this.isUserCodesEqual(userCodes, selectingUserCodes)) {
      // 同じであれば更新しない
      // ※プリセット由来で指定されたとき以外は同じになっている
      return;
    }
    this.isLoading = true;
    try {
      this.editingSource = await this.getUsers(userCodes);
    } finally {
      this.isLoading = false;
    }
  }

  private isUserCodesEqual(left: string[], right: string[]) {
    const leftCodes = left ? left : [];
    const rightCodes = right ? right : [];
    if (leftCodes.length !== rightCodes.length) { return false; }
    if (leftCodes.length === 0 && rightCodes.length === 0) { return true; }

    const sortedLeft = Enumerable.from(leftCodes).orderBy(l => l).toArray();
    const sortedRight = Enumerable.from(rightCodes).orderBy(r => r).toArray();
    for (let i = 0; i < sortedLeft.length; ++i) {
      if (sortedLeft[i] !== sortedRight[i]) { return false; }
    }
    return true;
  }

  private async getUsers(userCodes: string[]): Promise<User[]> {
    if (!userCodes || userCodes.length === 0) { return []; }

    const users: User[] = [];
    for (const userCode of userCodes) {
      const user = await this.getUserWithCatch(userCode);
      users.push(user);
    }
    return users;
  }

  private async getUserWithCatch(userCode: string): Promise<User> {
    try {
      if (!this._usersIncludingExpired) {
        const repo = DomainRegistry.user.getUserRepository();
        this._usersIncludingExpired = await repo.getAllUsers(true);
      }
      const userCodeAsUpper = userCode.toUpperCase();
      const user = Enumerable.from(this._usersIncludingExpired).firstOrDefault(u => u.id.toUpperCase() === userCodeAsUpper);
      if (!user) { throw new Error("ユーザーが見つかりませんでした。UserCode=" + userCode); }
      return user;
    } catch (e) {
      this.$logger.error(e);
      return new User(userCode, "不明な職員(" + userCode + ")", null, "", "", "");
    }
  }
}
